<div class="ai-dashboard">
    <!-- Header -->
    <div class="ai-dashboard__header">
        <div class="ai-dashboard__title-section">
            <h1 class="ai-dashboard__title">{{ 'ai-admin.dashboard.title' | translate }}</h1>
            <p class="ai-dashboard__subtitle">
                {{ 'ai-admin.dashboard.subtitle' | translate }}
            </p>
        </div>

        <!-- Period Selector -->
        <div class="ai-dashboard__period-selector">
            <button
                *ngFor="let period of ['month', 'all-time']"
                [class.active]="selectedPeriod === period"
                (click)="changePeriod(period)"
                class="ai-dashboard__period-btn"
            >
                {{ period === "month" ? ('ai-admin.dashboard.period.this-month' | translate) : ('ai-admin.dashboard.period.all-time' | translate) }}
            </button>
        </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="ai-dashboard__loading">
        <p>{{ 'ai-admin.dashboard.loading' | translate }}</p>
    </div>

    <!-- Error State -->
    <div *ngIf="!loading && error" class="ai-dashboard__error">
        <div class="ai-dashboard__error-icon">⚠️</div>
        <div class="ai-dashboard__error-message">{{ error }}</div>
    </div>

    <!-- Content -->
    <div *ngIf="!loading && stats" class="ai-dashboard__content">
        <!-- KPI Cards -->
        <div class="ai-dashboard__kpi-grid">
            <!-- Tokens Card -->
            <div class="ai-dashboard__kpi-card">
                <div class="ai-dashboard__kpi-label">{{ 'ai-admin.dashboard.kpi.tokens.label' | translate }}</div>
                <div class="ai-dashboard__kpi-value">
                    {{ getTokensValue() | number }}
                </div>
                <div class="ai-dashboard__kpi-subtitle">
                    {{ 'ai-admin.dashboard.kpi.tokens.subtitle' | translate }}
                </div>
            </div>

            <!-- Queries Card -->
            <div class="ai-dashboard__kpi-card">
                <div class="ai-dashboard__kpi-label">{{ 'ai-admin.dashboard.kpi.queries.label' | translate }}</div>
                <div class="ai-dashboard__kpi-value">
                    {{ getQueriesValue() | number }}
                </div>
                <div class="ai-dashboard__kpi-subtitle">
                    {{ 'ai-admin.dashboard.kpi.queries.subtitle' | translate }}
                </div>
            </div>

            <!-- Active Users Card -->
            <div class="ai-dashboard__kpi-card">
                <div class="ai-dashboard__kpi-label">{{ 'ai-admin.dashboard.kpi.users.label' | translate }}</div>
                <div class="ai-dashboard__kpi-value">
                    {{ getUsersValue() | number }}
                </div>
                <div class="ai-dashboard__kpi-subtitle">{{ 'ai-admin.dashboard.kpi.users.subtitle' | translate }}</div>
            </div>
        </div>

        <!-- Activity Chart -->
        <div class="ai-dashboard__section">
            <h2 class="ai-dashboard__section-title">
                {{ 'ai-admin.dashboard.chart.title' | translate }}
            </h2>
            <div class="ai-dashboard__chart">
                <div class="ai-dashboard__chart-bars">
                    <div
                        *ngFor="let day of stats.tokensByDay"
                        class="ai-dashboard__bar-container"
                    >
                        <div class="ai-dashboard__bar-wrapper">
                            <div
                                class="ai-dashboard__bar"
                                [style.height]="getBarWidth(day.tokens)"
                                [title]="
                                    day.date + ' - ' + day.tokens + ' tokens'
                                "
                            ></div>
                        </div>
                        <div class="ai-dashboard__bar-label">
                            {{ day.date | date: "d/M" }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Top Users Table -->
        <div class="ai-dashboard__section">
            <h2 class="ai-dashboard__section-title">
                {{ 'ai-admin.dashboard.top-users.title' | translate }}
            </h2>
            <div class="ai-dashboard__table-wrapper">
                <table class="ai-dashboard__table">
                    <thead>
                        <tr>
                            <th>{{ 'ai-admin.dashboard.top-users.col.user' | translate }}</th>
                            <th>{{ 'ai-admin.dashboard.top-users.col.email' | translate }}</th>
                            <th>{{ 'ai-admin.dashboard.top-users.col.tokens' | translate }}</th>
                            <th>{{ 'ai-admin.dashboard.top-users.col.queries' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of stats.topUsers">
                            <td>{{ getUserDisplayName(user) }}</td>
                            <td>{{ user.email }}</td>
                            <td class="ai-dashboard__table-number">
                                {{ user.tokens | number }}
                            </td>
                            <td class="ai-dashboard__table-number">
                                {{ user.queries | number }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Query Type Breakdown -->
        <div class="ai-dashboard__section">
            <h2 class="ai-dashboard__section-title">{{ 'ai-admin.dashboard.query-types.title' | translate }}</h2>
            <div class="ai-dashboard__breakdown">
                <div
                    *ngFor="let type of stats.queryTypeBreakdown"
                    class="ai-dashboard__breakdown-item"
                >
                    <div class="ai-dashboard__breakdown-header">
                        <span class="ai-dashboard__breakdown-type">{{
                            type.type
                        }}</span>
                        <span class="ai-dashboard__breakdown-count">{{
                            type.count
                        }}</span>
                    </div>
                    <div class="ai-dashboard__breakdown-bar-container">
                        <div
                            class="ai-dashboard__breakdown-bar"
                            [style.width]="type.percentage + '%'"
                        ></div>
                    </div>
                    <div class="ai-dashboard__breakdown-percentage">
                        {{ type.percentage | number: "1.0-1" }}%
                    </div>
                </div>
            </div>
        </div>

        <!-- Info Note -->
        <div class="ai-dashboard__info-box">
            <p>
                <strong>{{ 'ai-admin.dashboard.note' | translate }}</strong>
            </p>
        </div>

        <!-- Explicación de Tokens -->
        <div class="ai-dashboard__section">
            <h2 class="ai-dashboard__section-title">
                {{ 'ai-admin.tokens.section-title' | translate }}
            </h2>
            <div class="ai-dashboard__explanation">
                <div class="ai-dashboard__explanation-item">
                    <h3 class="ai-dashboard__explanation-title">
                        {{ 'ai-admin.tokens.what-is.title' | translate }}
                    </h3>
                    <p class="ai-dashboard__explanation-text">
                        {{ 'ai-admin.tokens.what-is.description' | translate }}
                    </p>
                    <ul class="ai-dashboard__explanation-list">
                        <li>{{ 'ai-admin.tokens.what-is.approx-1' | translate }}</li>
                        <li>{{ 'ai-admin.tokens.what-is.approx-2' | translate }}</li>
                        <li>{{ 'ai-admin.tokens.what-is.approx-3' | translate }}</li>
                    </ul>
                </div>
                <div class="ai-dashboard__explanation-item">
                    <h3 class="ai-dashboard__explanation-title">
                        {{ 'ai-admin.tokens.example.title' | translate }}
                    </h3>
                    <div class="ai-dashboard__code-example">
                        <div class="ai-dashboard__code-line">
                            <span class="ai-dashboard__code-label"
                                >{{ 'ai-admin.tokens.example.user-question' | translate }}</span
                            >
                            <span class="ai-dashboard__code-content"
                                >"¿Cuáles son los mejores cursos de
                                Python?"</span
                            >
                        </div>
                        <div class="ai-dashboard__code-line">
                            <span class="ai-dashboard__code-label"
                                >{{ 'ai-admin.tokens.example.input-tokens' | translate }}</span
                            >
                            <span class="ai-dashboard__code-content"
                                >~15 tokens</span
                            >
                        </div>
                        <div class="ai-dashboard__code-line">
                            <span class="ai-dashboard__code-label"
                                >{{ 'ai-admin.tokens.example.ai-response' | translate }}</span
                            >
                            <span class="ai-dashboard__code-content"
                                >~200 tokens (párrafo con 3-4 cursos
                                recomendados)</span
                            >
                        </div>
                        <div
                            class="ai-dashboard__code-line ai-dashboard__code-line--total"
                        >
                            <span class="ai-dashboard__code-label">{{ 'ai-admin.tokens.example.total' | translate }}</span>
                            <span class="ai-dashboard__code-content"
                                >~215 tokens</span
                            >
                        </div>
                    </div>
                </div>
                <div class="ai-dashboard__explanation-item">
                    <h3 class="ai-dashboard__explanation-title">
                        {{ 'ai-admin.tokens.tips.title' | translate }}
                    </h3>
                    <ul class="ai-dashboard__explanation-list">
                        <li>
                            {{ 'ai-admin.tokens.tips.tip-1' | translate }}
                        </li>
                        <li>{{ 'ai-admin.tokens.tips.tip-2' | translate }}</li>
                        <li>{{ 'ai-admin.tokens.tips.tip-3' | translate }}</li>
                        <li>
                            {{ 'ai-admin.tokens.tips.tip-4' | translate }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
